import { HTTPServiceClient } from '@/packages/http/service';
import * as t from './endpoints';
import { AggregatedForecastItem } from './types';
/**
 * --------------------------------------------------
 *	Forecast HTTP Serice
 * --------------------------------------------------
 **/
export const ForecastService = {
  fetchForecastAggregateDetails(
    organizationId: string
  ): Promise<AggregatedForecastItem[]> {
    return HTTPServiceClient.get(
      t.FETCH_FORECAST_AGGREGATE_DETAILS(organizationId)
    ).then(({ data }) => data);
  }
};
